import request from '@/utils/request'

export function selectProductTypeSpread(data) {
    return request({
        module: 'center',
        url: '/statistical/count/group/product',
        method: 'post',
        data: data
    })
}

export function selectInsertDevice() {
    return request({
        module: 'center',
        url: '/statistical/count/group/equipmentDeployment',
        method: 'post'
    })
}

export function selectArrangeAreaNumber() {
    return request({
        module: 'center',
        url: '/statistical/count/cityDeployment',
        method: 'post'
    })
}

export function selectProductArrange() {
    return request({
        module: 'center',
        url: '/statistical/trend/productDeployment',
        method: 'post'
    })
}

export function selectReverseNumbers() {
    return request({
        module: 'center',
        url: '/statistical/count/reverse',
        method: 'post'
    })
}

export function selectTodayReverseExceptionNumber() {
    return request({
        module: 'center',
        url: '/statistical/count/today/reverseException',
        method: 'post'
    })
}

export function selectTotalTurnover() {
    return request({
        module: 'center',
        url: '/statistical/trend/group/reverse',
        method: 'post'
    })
}

export function selectDealEventNumber() {
    return request({
        module: 'center',
        url: '/statistical/count/reverseException',
        method: 'post'
    })
}

export function selectInsertCourt() {
    return request({
        module: 'center',
        url: '/statistical/count/group/courtDeployment',
        method: 'post'
    })
}

export function selectdeployedDevicesTotalNumber() {
    return request({
        module: 'center',
        url: '/statistical/count/city/equipmentDeployment',
        method: 'post'
    })
}

export function selectAllException() {
    return request({
        module: 'center',
        url: '/statistical/list/reverseException',
        method: 'post'
    })
}



// WEBPACK FOOTER //
// ./src/api/center/statistical.js